import { useCallback, useState } from 'react'

export const useProcessScopeSearchSelect = () => {
  const [temporarySelection, setTemporarySelection] = useState<Set<string>>(
    new Set()
  )

  const toggleItem = useCallback((value: string) => {
    setTemporarySelection(prev => {
      const next = new Set(prev)
      if (next.has(value)) {
        next.delete(value)
      } else {
        next.add(value)
      }
      return next
    })
  }, [])

  const applySelection = useCallback(() => {
    return Array.from(temporarySelection)
  }, [temporarySelection])

  const resetToInitial = useCallback((values: string[]) => {
    setTemporarySelection(new Set(values))
  }, [])

  return {
    temporarySelection,
    toggleItem,
    applySelection,
    resetToInitial,
  }
}
